import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import {RouterProvider } from "react-router-dom";
import { Provider } from 'react-redux';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Router from './router/Router';
import { store } from './store';
import AuthInitializer from './components/AuthInitializer';
import './service/bmk-service.js'; // Initialize the service

// Expose Redux store to window object for router loaders
window.__REDUX_STORE__ = store;

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
            <Provider store={store}>
                <AuthInitializer>
                    <RouterProvider router={Router} />
                </AuthInitializer>
            </Provider>
        </GoogleOAuthProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
